import { UserDetails } from '../types/schemas/abc';

export type MatchStatus = 'exact' | 'partial' | 'none';

export interface MatchDetails {
  [subject: string]: {
    [level: string]: MatchStatus;
  };
}

export const calculateComprehensiveMatch = (parent: UserDetails, tutor: UserDetails) => {
  const parentExpertise = parent.expertise || {};
  const tutorExpertise = tutor.expertise || {};
  const tutorSubjects = new Set(tutor.subjects || []);

  let exactMatches = 0;
  let partialMatches = 0;
  let totalRequirements = 0;
  const matchDetails: MatchDetails = {};

  for (const subject in parentExpertise) {
    if (!matchDetails[subject]) {
      matchDetails[subject] = {};
    }
    
    const requiredLevels = parentExpertise[subject] || [];
    const taughtLevels = new Set(tutorExpertise[subject] || []);
    let isPartialMatch = false;

    for (const level of requiredLevels) {
      totalRequirements++;
      if (taughtLevels.has(level)) {
        // Exact match: Tutor teaches this specific subject and level
        exactMatches++;
        matchDetails[subject][level] = 'exact';
      } else {
        // No exact match for this level
        matchDetails[subject][level] = 'none';
        if (tutorSubjects.has(subject)) {
          // But, the tutor *does* teach the subject overall
          isPartialMatch = true;
        }
      }
    }
    // If we found a partial match for any level in this subject, mark all non-exact levels as partial
    if (isPartialMatch) {
      partialMatches++;
      for (const level of requiredLevels) {
        if (matchDetails[subject][level] === 'none') {
            matchDetails[subject][level] = 'partial';
        }
      }
    }
  }

  return { exactMatches, partialMatches, totalRequirements, matchDetails };
};